

























































import { Groupe } from "@/shared/Groupe";
import { Component } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import MobileMixin from "@/mixins/mobileMixin";

@Component({
  components: {},
})
export default class ListeGroupes extends mixins(MobileMixin) {
  public searchTxtGr: string = "";
  public selectedGroupe: string = "";
  public showMenu = false;

  /*
   * methode de filtre depuis le champs de texte des sites repondant au critere de texte
   */
  public groupementsFil() {
    let mesGroupes = new Array();
    if (this.searchTxtGr.trim() === "") {
      return this.groupements;
    } else if (this.searchTxtGr.trim() !== "") {
      mesGroupes = this.groupements.filter((gr: Groupe) => {
        return gr.raisonSociale
          .toUpperCase()
          .includes(this.searchTxtGr.toUpperCase());
      });
    }
    return mesGroupes;
  }

  public selectGroup(gr: any) {
    this.selectedGroupe = gr;
    this.showMenu = false;
    this.$emit("selectGroupe", this.selectedGroupe);
  }

  /*
   * ensemble des groupements existants
   */
  get groupements(): Groupe[] {
    const gpm = this.$store.getters["login/groupements"];
    return gpm;
  }

  get client(): string {
    return this.$store.getters["getClient"];
  }
}
